//import components
import mainnav from '@/components/_globals/mainnav/mainnav.vue'
import projectSlides from '@/components/projects/project-slides/project-slides.vue'

//import swiper plugin
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

//import json data
import projects from '@/assets/json/projects/projects.json'

export default {
  name: 'project',
  components: {
    swiper,
    swiperSlide,
    mainnav,
    projectSlides
  },
  data: function () {
    return {
      projectId: null,
      arrayKey: null,
      renderData: [],
      sliderMax: null,
      projects: projects,
      image: null
    }
  },
  created: function () {
    let id = this.$route.params.slug
    this.projectId = parseInt(id)
    this.arrayKey = this.projectId - 1

    this.renderData = projects[this.arrayKey]

    this.renderData = projects[this.arrayKey]
    const maxValue = parseInt(this.projects.length)

    this.sliderMax = maxValue
  },
  computed: {
    currentLocale: function() {
      return this.$i18n.locale
    },
    projectImage: function () {
      return this.renderData.main.image
    }

  },
  methods: {
    previousProject: function () {
      if(this.projectId > 1) {
        this.projectId = this.projectId - 1
        this.arrayKey = this.arrayKey - 1
        this.renderData = projects[this.arrayKey]
        history.pushState({}, null, `/projects/${this.projectId}`)
      }
    },
    nextProject: function () {
      const maxValue = parseInt(this.projects.length)
      if(this.projectId < maxValue) {
        this.projectId = this.projectId + 1
        this.arrayKey = this.arrayKey + 1 
        this.renderData = projects[this.arrayKey]
        history.pushState({}, null, `/projects/${this.projectId}`)
      } 
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/projects/project/project.js